import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { VoucherCouponDetail } from 'app/models/voucherCouponMg.model';
import { AuthService } from './../../services/user/auth.service';
import { DatePipe } from '@angular/common';
import { CalendarTranslateService } from './../../modules/UIKit/services/calendarTranslate.service';
import { CalendarService } from './../../services/calendar/calendar.service';
import { KontableNewComponent } from './../../modules/UIKit/components/kontablenew/kontablenew.component';
import { DataTableCustomButton } from './../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { transition } from '@angular/animations';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from './../../modules/UIKit/components/kontable/kontable.component';
import { VoucherCouponService } from './../../services/voucher-coupon-mg/voucher-coupon.service';
import { VoucherCoupon, Channel, Context } from './../../models/voucherCouponMg.model';
import { FormBuilder, FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-voucher-coupon-mg',
  templateUrl: './voucher-coupon-mg.component.html',
  styleUrls: ['./voucher-coupon-mg.component.css']
})
export class VoucherCouponMgComponent implements OnInit {

  @ViewChild('couponListTable') couponListTable: KontableNewComponent;

  form: FormGroup;  

  show = {
    context: false,
    editModal: false
  }
  
  
  headerFilters = {
    channel: null,
    store: null,
    expired: false
  }

  newDataAvailable: boolean = false;

  initialFilters = new Array<{key: string, value: any}>();

  customButtons: DataTableCustomButton[];  
  customFilter = KontableNewComponent.CustomFilter;  
  dateFilter = KontableNewComponent.DateFilter;
  filters: Array<{field: string, value: any}> = [];
  translations: any;  
  paginationType = KontableNewComponent.ServerPagination;
  textFilter = KontableNewComponent.TextFilter;  
  currentVoucherCoupon: VoucherCoupon;
  currentVoucherCouponDetail: VoucherCouponDetail;
  context: Context;  
  selectPrinted: Array<{value: boolean, label: string}>;
  selectState: Array<{value: string, label: string}>;
  selectIssue: Array<{value: string, label: string}>;
  selectType: Array<{value: string, label: string}>;  
  selectChannel_ALL: Array<{value: string, label: string, localId: string}>;
  selectStore_ALL: Array<{value: string, label: string, localChannelId: string }>;
  selectChannel: Array<{value: string, label: string, localId: string}>;
  selectStore: Array<{value: string, label: string, localChannelId: string }>;   
  currentFootprint: string = ""; 

  staticTable: boolean = true;

  model = {
    issue: null,
    type: null,
    state: null,
    printed: null,
    voucherId: null,
    cardId: null
  }

  srcBarcode: SafeResourceUrl = null;
  showBarcodeModal: boolean = false;

  couponVoucherId: string = "";
  cardId: string = "";

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private srvVoucherCoupon: VoucherCouponService,
    private srvTranslate: TranslateService,
    private srvCalTranslate: CalendarTranslateService,    
    private srvAuth: AuthService,    
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    ) { }

  ngOnInit() {

   var self = this;
   this.selectState = [];
   this.selectPrinted = [];
   this.selectIssue = [];
   this.selectType = [];
   this.selectStore_ALL = [];
   this.selectChannel_ALL = [];

   
   this.couponVoucherId = this.route.snapshot.queryParams['couponVoucherId'] ? this.route.snapshot.queryParams['couponVoucherId'] : "";
   this.cardId = (this.route.snapshot.queryParams['cardId'] && this.route.snapshot.queryParams['cardId'] != "0") ? this.route.snapshot.queryParams['cardId'] : "";

   const TRANSLATIONS =   this.srvTranslate.get([    
    'common.yes',
    'common.no'
  ]);
    
/*
  self.kontable.columns.customerCode = this.activatedRoute.snapshot.queryParams['customerCode'];
}
$('.field-customerCode input').val(this.activatedRoute.snapshot.queryParams['customerCode']);
*/


  //carica dati di contesto statici, cioè lista tipi coupon, lista eanvalue, lista negozi, ecc...
  const CONTEXT =  this.srvVoucherCoupon.getContext();
  
  Observable.zip(
    TRANSLATIONS,
    CONTEXT
  ).subscribe(([resTranslation, resContext]) => {
  
    if(resTranslation){
     this.translations = resTranslation;
     this.loadSelectPrinted();
    }
  
    if(resContext){                   
      self.context = resContext;      
      self.currentFootprint = self.context.footprint;

      self.selectState.push({ label: '', value: null });
      self.context.voucherStateList.forEach(element => {
        self.selectState.push({label: element.description, value: element.code});
      });

      self.selectIssue.push({ label: '', value: null });
      self.context.issueTypeList.forEach(element => {
        self.selectIssue.push({label: element.description, value: element.code});
      });

      self.selectType.push({ label: '', value: null });
      self.context.voucherTypeList.forEach(element => {
        self.selectType.push({label: element.description, value: element.code});
      });

      self.selectChannel_ALL.push({ label: '', value: null, localId: null });
      self.context.channelList.forEach(element => {
        self.selectChannel_ALL.push({label: element.description, value: element.code, localId: element.localId});
      });

      self.selectStore_ALL.push({ label: '', value: null, localChannelId: null });
      self.context.storeList.forEach(element => {
        self.selectStore_ALL.push({label: (element.code ? (element.code + " - " + element.description) :  element.description), value: element.code, localChannelId: element.localChannelId});
      });

      self.selectChannel = Object.assign([],this.selectChannel_ALL);            

      self.show.context = true; 
      
      var self2 = self;
      setTimeout(function(){        
        self2.couponListTable.fixedFilters.push({key: "footprint", value: self2.currentFootprint });
        self2.couponListTable.fixedFilters.push({key: "showExpired", value: false});

        /*** 
         * se è valorizzato cardId (se il coupon che stavo vedendo in dettaglio ha la carta collegata e ho premuto indietro) 
         * la lista deve essere filtrata per quella carta.
         * se non è valorizzato cardId, allora la lista deve essere filtrata per quel voucherId
         * ***/
        
        if(self2.cardId != "" || self2.couponVoucherId != ""){
          if(self2.cardId != ""){
            self2.couponListTable.filter.search.push({key: 'cardId', value: self2.cardId});
            $('#cardIdFilter').val(self2.cardId);
          }
          else{
            if(self2.couponVoucherId != ""){
              self2.couponListTable.filter.search.push({key: 'voucherId', value: self2.couponVoucherId});
              $('#voucherIdFilter').val(self2.couponVoucherId);
            }
          }
          //questa è la stesso comando che si dà quando si clicca su applica filtri
          self2.couponListTable.updateTableFilter(null, null, null, 1, 1000, true);
        }
        
      },100);
      //carica dati di contesto statici, cioè lista tipi coupon, lista eanvalue, lista negozi, ecc...      
    }
  });
  }
  onChangeExpired(){        
    let indexExpired = this.couponListTable.fixedFilters.findIndex(x=>x.key == "showExpired");   
    
    if(indexExpired>-1){
      this.couponListTable.fixedFilters[indexExpired].value = this.headerFilters.expired;
    }
    else{
      this.couponListTable.fixedFilters.push({key: "showExpired", value: this.headerFilters.expired});
    }
  }
  onChangeStore(){    
    let indexStore = this.couponListTable.fixedFilters.findIndex(x=>x.key == "storeCode");
    if(this.headerFilters.store){            
      if(indexStore>-1){
        this.couponListTable.fixedFilters[indexStore].value = this.headerFilters.store.value;
      }
      else{
        this.couponListTable.fixedFilters.push({key: "storeCode", value: this.headerFilters.store.value});
      }      
    }
    else{
      if(indexStore>-1){
        this.couponListTable.fixedFilters.splice(indexStore,1);
      }   
    }
  }    
  onChangeChannel(){    
    this.headerFilters.store = null;    
    let indexChannel = this.couponListTable.fixedFilters.findIndex(x=>x.key == "channelCode");

    if(this.headerFilters.channel){
      
      if(indexChannel>-1){
        this.couponListTable.fixedFilters[indexChannel].value = this.headerFilters.channel.value
      }
      else{
        this.couponListTable.fixedFilters.push({key: "channelCode", value: this.headerFilters.channel.value});
      }      

      this.selectStore = this.selectStore_ALL.filter(x=>x.localChannelId == this.headerFilters.channel.localId);
      this.selectStore.unshift({label: "", value: null, localChannelId: null });
    }
    else{
      this.selectStore =  Object.assign([],this.selectStore_ALL);      
      if(indexChannel>-1){
        this.couponListTable.fixedFilters.splice(indexChannel,1);
      }              
    }
  }
  loadSelectPrinted(){
    this.selectPrinted.push({ label: '', value: null });
    this.selectPrinted.push({ label: this.translations['common.yes'], value: true });
    this.selectPrinted.push({ label: this.translations['common.no'], value: false });
  }
  updatePrintedFilter(event){        
    let index = this.couponListTable.filter.search.findIndex(x=>x.key == 'printed');
    if(index > -1){      
      if(event.value){
        this.couponListTable.filter.search[index].value = event.value;
      }
      else{
        this.couponListTable.filter.search.splice(index,1);
      }
    }
    else{
      this.couponListTable.filter.search.push({key: 'printed', value: event.value});
    }    
  }
  clearFilters(){
    this.couponListTable.filter.search = [];
    this.model.issue = null;
    this.model.printed = null;
    this.model.state = null;
    this.model.type = null;
  }
  updateStateFilter(event){    
    let index = this.couponListTable.filter.search.findIndex(x=>x.key == 'voucherStateCode');
    if(index > -1){
      if(event.value){
        this.couponListTable.filter.search[index].value = event.value;
      }
      else{
        this.couponListTable.filter.search.splice(index,1);
      }
    }
    else{
      this.couponListTable.filter.search.push({key: 'voucherStateCode', value: event.value});
    }    
  }
  updateIssueFilter(event){    
    let index = this.couponListTable.filter.search.findIndex(x=>x.key == 'issueTypeCode');
    if(index > -1){
      if(event.value){
        this.couponListTable.filter.search[index].value = event.value;
      }
      else{
        this.couponListTable.filter.search.splice(index,1);
      }      
    }
    else{
      this.couponListTable.filter.search.push({key: 'issueTypeCode', value: event.value});
    }   
  }
  updateTypeFilter(event){        
    let index = this.couponListTable.filter.search.findIndex(x=>x.key == 'voucherTypeCode');
    if(index > -1){
      if(event.value){
        this.couponListTable.filter.search[index].value = event.value;
      }
      else{
        this.couponListTable.filter.search.splice(index,1);
      }
    }
    else{
      this.couponListTable.filter.search.push({key: 'voucherTypeCode', value: event.value});
    }    
  }  
  updateVoucherIdFilter(){
    let index = this.couponListTable.filter.search.findIndex(x=>x.key == 'voucherId');
    if(index > -1){
      if(this.model.voucherId){
        this.couponListTable.filter.search[index].value = this.model.voucherId;
      }
      else{
        this.couponListTable.filter.search.splice(index,1);
      }
    }
    else{
      this.couponListTable.filter.search.push({key: 'voucherId', value: this.model.voucherId});
    }    
  }
  updateCardIdFilter(){
    let index = this.couponListTable.filter.search.findIndex(x=>x.key == 'cardId');
    if(index > -1){
      if(this.model.cardId){
        this.couponListTable.filter.search[index].value = this.model.cardId;
      }
      else{
        this.couponListTable.filter.search.splice(index,1);
      }
    }
    else{
      this.couponListTable.filter.search.push({key: 'cardId', value: this.model.cardId});
    }    
  }
  edit(event: VoucherCoupon){       
    
    this.currentVoucherCoupon = event;    

    var self = this;    

    this.srvVoucherCoupon.getDetails(this.currentVoucherCoupon.voucherId,this.currentVoucherCoupon.eanCode,this.context.footprint).subscribe(res=>{      
      if(res){
        let index = this.context.voucherStateList.findIndex(x=>x.code == res.voucherStateCode);
        self.currentVoucherCouponDetail = res;
        self.form = self.fb.group({
          'status': new FormControl(Object.assign({},this.context.voucherStateList[index])),
          'printed': new FormControl(res.printed)
        });  
        self.show.editModal = true;
      }      
    });  

  }
  info(event: VoucherCoupon){        
    this.router.navigate(['/voucher-coupon-mg/' + event.voucherId + "/" + (event.cardId ? event.cardId : "0")]);
  }
  getState(code: string){    
    let res = "";
    let index = this.context.voucherStateList.findIndex(x=>x.code == code);
    if(index>-1){
      res = this.context.voucherStateList[index].description;
    }
    else{
      res = code;
    }
    return res;
  }
  getIssueType(code: string){        
    let res = "";
    let index = this.context.issueTypeList.findIndex(x=>x.code == code);
    if(index>-1){      
      res = this.context.issueTypeList[index].description;
    }
    else{
      res = code;
    }
    return res;
  }
  getVoucherType(code: string){        
    let res = "";
    let index = this.context.voucherTypeList.findIndex(x=>x.code == code);
    if(index>-1){
      res = this.context.voucherTypeList[index].description;
    }
    else{
      res = code;
    }
    return res;
  }  
  getDate(dateString: string){
    if(dateString && dateString.length > 0){
      return moment(dateString).format(this.srvCalTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase());
    }
    else{
      return "";
    }
    
  }    
  onClickPerformEdit(){
    var self = this;
    this.srvVoucherCoupon.editVoucherCoupon(this.currentFootprint,this.currentVoucherCouponDetail.eanCode,this.currentVoucherCouponDetail.voucherId,this.form.get('printed').value,this.form.get('status').value.code).subscribe(res=>{
      
      if(res){
        self.newDataAvailable = true;
        self.show.editModal = false;
      }      
    });    
  }  
  getBarcodeImageByCardNo(cardNo: string,index = -1){    
    var JsBarcode = require('jsbarcode');

    if($('#barcode' + (index > -1 ? index.toString() : "")).length){
      JsBarcode("#barcode" + (index > -1 ? index.toString() : ""), cardNo, {
        format: "CODE128",
        lineColor: "#000",
        width:2,
        height:40,
        background: "transparent",
        displayValue: true
      });

      var svg = $("#barcode" + (index > -1 ? index.toString() : ""))[0];

      var xml = new XMLSerializer().serializeToString(svg);

      var base64 = 'data:image/svg+xml;base64,' + btoa(xml);

      return base64;
    }
    return '';
  }
  onClickVisualizzaBarcode(barcode: string) {          
      this.srcBarcode = this.sanitizer.bypassSecurityTrustResourceUrl(this.getBarcodeImageByCardNo(barcode));
      this.showBarcodeModal = true;    
  }
}



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg.component.ts